import React, { useState } from "react";
import {
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { ChecklistDetail } from "./ChecklistDetail";
import { Pageview } from "@mui/icons-material";

export const Checklists = ({ user }) => {
  const [selectedChecklist, setSelectedChecklist] = useState(null);

  const checklists = [
    {
      id: 1,
      title: "Safety checklist for Deck Officers",
      sections: [
        {
          title: "Before Arrival Sign",
          items: [
            {
              text: "If vessel is inerted, oxygen level in cargo tanks to be verified to be under 8%. If above 8% cargo tanks to be purged down to below 8% before taking pilot.",
            },
            {
              text: "Prepare mooring ropes, gangway, safety net, lifebuoy according 'Port call' binder.",
            },
            {
              text: "Hand over national flag for hoist in forward mast SB side by AB. Company and 'B' flag if applicable in aft mast, and ship's nationality flag aft.",
              note: "All flags to be used / raised in daylight only.",
            },
            { text: "Open ventilation hatches for bow thruster." },
            { text: "Anchors ready for Emergency use." },
            {
              text: "P/V valves function tested. Flame screen on vac. valve checked. Secondary venting system, pressure sensors to be checked/adjusted for correct reading of ATM pressure.",
            },
            {
              text: "Scuppers effectively plugged, rubber quality checked if worn out or cracked.",
            },
            {
              text: "Fire-fighting and oil spill equipment positioned and ready for immediate use.",
            },
            {
              text: "Tank-, butterworth- and ullage hatches all closed.",
              note: "Manually check the hatches to ensure that they are secure.",
            },
            {
              text: "Ensure that bolted flange connections are suitably bolted.",
            },
            {
              text: "Unless otherwise decided by Master, external doors for accommodation unlocked for easy access by fire brigade in ISPS ports.",
            },
            {
              text: "Line up deck drain system for immediate use. (Remote op. from CCR if fitted).",
            },
            {
              text: "Measure vapour in EMPTY ballast TK´s (using fixed system/Salvico, if applicable). Sampling points must be DISCONNECTED BEFORE FILLING ballast and shall only be re-connected when ballast TK´s are empty.",
            },
            {
              text: "Prepare visitor log, all visitors to show ID. Copy O:\\Visitors list.",
            },
            {
              text: "Visual inspection of mooring lines intended for use for subject mooring arrangement.",
            },
          ],
        },
        {
          title: "Alongside / Cargo Operation Sign",
          items: [
            {
              text: "Check that anchors are secured by locking bar 'bears' only.",
            },
            {
              text: "Emergency towing wires correctly positioned according to mooring procedures if required by installation.",
            },
            { text: "Fill in ship to shore safety checklist." },
            {
              text: "Local emergency contact list received from shore side, to be posted in CCR.",
            },
            {
              text: "Agreed ship/shore communication system and emergency shut down procedure.",
            },
            {
              text: "Cargo independent 95% and 98% High Level alarm activated and tested.",
            },
            {
              text: "Follow safety precautions acc. to MSDS, posted in CCR and 1st poop deck. Precautions for static electricity must be taken, where applicable. Where applicable, a copy of the USCG Data Guide should be on board.",
            },
            {
              text: "Change accommodation air inlet to coal filter mode if applicable and all natural vents into accommodation to be closed.",
            },
            {
              text: "Manifolds drains closed and lining-up for cargo operation prepared acc. to Chief Officer´s order.",
            },
            {
              text: "Vinga series PR643 fixed deck drain pump line up ready for use.",
            },
            {
              text: "MESQAC H33. If rubber cargo hoses to be used, inspection prior each use to ensure free of kinks or any other deterioration or damages (rubber hose max 6 years). If not use cargo hose insert N/A.",
            },
            {
              text: "Lining-up to be cross checked by the Chief Officer before commencement of the cargo operation.",
              note: "If the cargo operation covers more than one cargo grade, the manifolds must be suitably marked for the specific cargo grade with a sign!",
            },
            {
              text: "In case the lining-up is done by the Chief Officer, a cross check should be done by OOW, including manifold signs.",
            },
            {
              text: "Prior to commencement of cargo operation, verify that the hoses are connected to the ship´s manifold as per agreement with the Terminal.",
            },
            {
              text: "All ballast tanks must be visually checked for oil contamination on each occasion before being discharged. OCIMF 6.31.",
            },
            {
              text: "During start loading of each parcel the first flow sample to be taken, see PR353.",
            },
            {
              text: "Cargo samples from each parcel taken by shore to be saved onboard for min 6 months. This is the ship's evidence and is not to be handed over to third party without owner’s approval. See PR353.",
            },
            {
              text: "If temperature of the loaded cargo is below zero the ballast to be discharged before cargo is loaded in the adjacent cargo tanks to avoid freezing.",
            },
            {
              text: "If chemical cargo operation: Check water supply to emergency showers.",
            },
            {
              text: "Co-mingling, dosing (dyes, additives) doping and/or blending of cargo alongside or at sea only allowed after written approval from Chartering department.",
            },
            {
              text: "TMSA 6A.2.3 If vessel cannot remain safely moored, proper action to be established, including: Deployment of additional mooring, Engage tug to remain alongside, Preparation for emergency departure.",
            },
            {
              text: "Cargo pump remote stops must be tested within 24h of expected cargo operation.",
            },
          ],
        },
        {
          title: "Frequently Checks Min Every Hrs Sign",
          items: [
            {
              text: "Check frequently that ship is securely moored, gangway and safety net and that ship not stuck on i.e. jetty fenders.",
            },
            {
              text: "Inform AB to make regular inspection of spill tray, aft cargo deck and inside pipe tunnel if fitted. Listen for abnormal noise.",
            },
            {
              text: "Regularly check of pressure on all manifolds includes not using.",
            },
            {
              text: "Regularly check of cargo tank pressure, over if load and under pressure if discharging.",
            },
            {
              text: "Re-check all letter 'R' acc. to ship/shore safety checklist.",
            },
            {
              text: "P/V valves to be checked for movement during sub-zero temperatures. Not applicable when/if vessel is under inert-gas operation.",
            },
            {
              text: "Stability, trim and stress checked. Records made in loading/disch. log. (ref. TMSA3 6.2.2)",
            },
            {
              text: "Weather forecast/warnings are obtained, including those for ice if applicable (ref. TMSA 6A2.3).",
            },
            {
              text: "Changes to environmental conditions, tidal stream, current and wind speed are monitored (ref. TMSA 6A2.3).",
            },
            { text: "Passing traffic are monitored (ref. TMSA 6A2.3)." },
            {
              text: "Sufficient personnel are retained onboard in order to tend the moorings (ref. TMSA 6A2.3).",
            },
          ],
        },
        {
          title: "Before Departure Sign",
          items: [
            { text: "Disconnect hose and blank manifolds." },
            { text: "Make sure load computer is on line." },
            {
              text: "Remote ullage gauge cross checks and verification if discrepancy above 0,3 % between BL / Ships figures. (ref. TMSA3 6.2.2)",
            },
            {
              text: "Re-tight/check all tank-, butterworth- and ullage hatches.",
              note: "Manually check the hatches to ensure that they are secure.",
            },
            {
              text: "Check and file both intact and damage stability condition as stated in Cargo Planning Loading procedure. PSC request/demand, Res. A.749(18) MSC.75(69).",
            },
            {
              text: "Empty manifold spill trays, by deck drain pump in local mode (remote if fitted in emergency only).",
            },
            { text: "Open scuppers." },
            { text: "Restore fire-fighting and oil spill equipment." },
            { text: "Change accommodation air inlet back to fresh air mode." },
            {
              text: "Secure all doors in closed position into stores aft, down to forecastle, pipe tunnel, etc.",
            },
            { text: "Secure gangway, safety net and fire wire." },
            {
              text: "Make safety walk around the vessel and check for stowaways and that all loose things are well secured.",
            },
          ],
        },
        {
          title: "After Departure Sign",
          items: [
            {
              text: "Pilot ladder out/in, close ventilation to bow thruster, secure anchor and haul down flags.",
            },
            { text: "Unlock all doors to accommodation." },
            {
              text: "AB confirms that UTI / Sampler equipment is properly stored and has been cleaned from last cargo. Before cleaning is started AB to inform Chief officer accordingly.",
            },
            {
              text: "Confirm with AB all flag to be taken down when start of sea passage. In good weather, the national flag can be raised aft in daytime if trading close to shore areas. If small national flag onboard it should be raised only in aft top mast middle dedicated 'fork' part.",
            },
          ],
        },
      ],
    },
    {
      title: "Ship Safety Checklist for AB on watch",
      sections: [
        {
          title: "Before Arrival Sign",
          items: [
            { text: "Prepare visitor list. Copy O:\\Visitors List" },
            { text: "Prepare mooring ropes." },
            {
              text: "Prepare gangway, safety net, lifebuoy and visitor sign.",
            },
            { text: "Rise signal and national flag acc to OOW advise" },
            { text: "Open ventilation hatches for bow thruster." },
            { text: "Make anchors ready for EM use" },
            {
              text: "P/V valves function tested. Flame screen and vacuum valve checked.",
            },
            {
              text: "Scuppers effectively plugged, rubber quality checked if worn out or cracked",
            },
            {
              text: "Fire-fighting and oil spill equipment positioned and ready for immediate use",
            },
            { text: "Tank, butterworth, ullage hatches all closed." },
            {
              text: "Ensure that bolted flange connections are suitably bolted.",
            },
            {
              text: "Close all external doors in the accommodation, keep them closed during port call.",
            },
            { text: "Line up deck drain system (SMPEP) for immediate use." },
            {
              text: "Ensure that the containment arrangement (spill trays) and its drain plugs are in good order for all bunker manifolds, cargo manifolds, slop manifolds and bunker tank vents including service and storage oil tank vents, deck hydraulic machinery.",
            },
            {
              text: "Hoist the national flag in forward mast sb side, company and other flag in aft top mast. Home port nation flag on 1st poop deck aft. No flag use at night time, only flags up during daytime.",
            },
          ],
        },
        {
          title: "Alongside / Cargo Operation Sign",
          items: [
            {
              text: "Check that anchors are secured by locking bar 'bears' only.",
            },
            {
              text: "Emergency towing wires correctly positioned acc to mooring procedures, if requested by the terminal.",
            },
            {
              text: "Use visitor list after officers advise, ask all visitors who he/she is + ID and whom looking for, after officers accept, show the visitor to bridge/CCR the outside way.",
              note: "Note the Visitor tag number in list when onboard and when leaving vessel + times. Ask for mobile phone and lighter. If visitor has mobile phone this has to be switched off, if visitor has lighter this has to be left ashore.",
            },
            {
              text: "Follow safety precautions acc. to MSDS placed outside deck office 1st poop deck.",
            },
            {
              text: "Manifolds drains closed and lining up for cargo operation prepared according to Chief Officer´s order, including manifold signs if more than one grade of cargo.",
            },
            {
              text: "All mooring drums to have only one layer of rope on the heaving split drum for proper brake opening before rope is broken if abnormal heavy load occur.",
            },
            {
              text: "Mooring winch clutch handle to be secured in open position, safety securing pins in position",
            },
            {
              text: "Deck watch stationed nearby the manifold area, both at shore side and off shore manifold during start loading/discharging, checking for leakage.",
            },
            {
              text: "Start sample on each parcel to be taken on the drain cock at manifold. PR385",
            },
            {
              text: "Deck watch to use PPE when sampling, enter pipe tunnel/pump room during cargo onboard. If entry into pipe trunk is required see FM111",
            },
            {
              text: "Open ullage ports or covers are not allowed during cargo operation, see PR353",
            },
            {
              text: "If chemical cargo operation: Check water supply to emergency showers.",
            },
            {
              text: "Signs 'Do not pass over or under mooring ropes' to be posted on mooring ropes which are crossing a walkway.",
            },
            {
              text: "After line-up for stripping cargo tanks, AB to be st-by at portable rubber hose connection position to check that there is no leaks from the hose connections, when pump is started.",
            },
          ],
        },
        {
          title: "Frequently Checks Min Every Hrs Sign",
          items: [
            {
              text: "Check frequently that ship is securely moored, gangway and safety net and that ship not stuck on i.e. jetty fenders.",
              note: "AB on duty that need to step over or under mooring ropes to release/tighten brake for adjusting ropes while in port should report to OOW when enter/clear of snap-back zone.",
            },
            {
              text: "AB to make regular inspection of spill tray, aft cargo deck and inside pipe tunnel if fitted/required. Before enter pipe tunnel if fitted call OOW permit to be issued.",
            },
            {
              text: "Listen for abnormal noise and report to OOW immediately if anything is found.",
            },
            {
              text: "Regularly check of pressure on all manifolds includes not using.",
            },
            {
              text: "Frequently check fire wire position over water level should be about 1.5m.",
            },
            {
              text: "Regularly check of cargo tank pressure, over if load and under pressure if discharging.",
            },
            {
              text: "Checks over the side minimum every hour. Particularly stern tube surrounding.",
            },
            {
              text: "P/V valves to be checked for movement during sub-zero temperatures. Not applicable when vessel is under inert-gas operation. If applicable a wooden stick is to be used for the movement test.",
            },
          ],
        },
        {
          title: "Before Departure Sign",
          items: [
            {
              text: "Assist shore personnel to disconnect hose and blank manifolds. All bolts to be inserted.",
            },
            {
              text: "Assist shore taking samples. Cargo samples from each parcel taken by shore to be saved onboard for min 3 months. This is the ship's evidence and is not to be handed over to third party without owner’s approval. See PR385",
            },
            {
              text: "Re-tight/check all tank and butterworth hatches with hand force. Report to OOW.",
            },
            {
              text: "Empty manifold spill trays. Use deck drain pump into deck drain tank. (Use REMOTE operation if fitted in CCR always in close cooperation with OOW.)",
            },
            { text: "Open scuppers and secure them for the sea voyage." },
            { text: "Restore fire-fighting and oil spill equipment" },
            {
              text: "Before fwd spring clutch/brake operation, ME load/pitch set to zero. PR218",
            },
          ],
        },
        {
          title: "After Departure Sign",
          items: [
            {
              text: "Secure all doors into stores aft, down to forecastle and into pipe tunnel",
            },
            {
              text: "Secure gangway, safety net and fire wire and unlock anchors.",
            },
            { text: "Pilot ladder in/out" },
            {
              text: "Close ventilation to bow thruster/forecastle, secure anchor and haul flags.",
            },
            {
              text: "Make safety walk around the vessel and check for stowaways and that loose things are well secured.",
            },
            {
              text: "Bring down the flags from masts and store them safe for next assignment/use.",
            },
            {
              text: "Check that UTI/Sampler equipment is properly stored and has been cleaned from last cargo. Before cleaning is started inform Chief officer accordingly.",
            },
            {
              text: "When this checklist is completed and signed, AB returns it to CCR for saving together with CL001 after Ch Off review.",
            },
          ],
        },
      ],
    },
  ];

  return (
    <div>
      {selectedChecklist ? (
        <ChecklistDetail
          checklist={selectedChecklist}
          goBack={() => setSelectedChecklist(null)}
        />
      ) : (
        <>
          <Typography variant="h4" sx={{ marginBottom: 2 }}>
            Checklists
          </Typography>
          <List>
            {checklists.map((checklist) => (
              <ListItem key={checklist.id} divider>
                <ListItemText primary={checklist.title} />
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Pageview />}
                  onClick={() => setSelectedChecklist(checklist)}
                >
                  View & Print
                </Button>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </div>
  );
};
